import { render, staticRenderFns } from "./BlockListNewsletter.vue?vue&type=template&id=64d17785&"
import script from "./BlockListNewsletter.vue?vue&type=script&lang=js&"
export * from "./BlockListNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./BlockListNewsletter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports